import { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@appsumo/dorado-react';

import { CheckoutButtonProps } from '~/types/checkout';
import { ADDITIONAL_PAYMENT_METHODS } from '~/constants/checkout';

import { Loader } from '~/components/ui';
import PaypalCheckout from './PaypalCheckout';

export default function CheckoutButton({
  isCheckoutDisabled,
  isPaymentPending,
  onSubmitPayment,
  selectedPaymentMethod,
  isCredits,
}: CheckoutButtonProps): ReactElement {
  if (
    selectedPaymentMethod ===
      ADDITIONAL_PAYMENT_METHODS.PAYPAL_PAYMENT_METHOD &&
    !isCredits
  ) {
    return (
      <div className="z-0">
        <PaypalCheckout isDisabled={isCheckoutDisabled} />
      </div>
    );
  }

  return (
    <Button
      className="flex w-full items-center justify-center"
      onClick={onSubmitPayment}
      disabled={isCheckoutDisabled}
      data-testid="summary-checkout-button"
    >
      <FontAwesomeIcon icon={faLock} className="mr-2" />
      Place order now
      {isPaymentPending && (
        <div className="ml-2">
          <Loader size="sm" />
        </div>
      )}
    </Button>
  );
}
